import { useContext } from "react";
import { SOrdnerOverviewContext } from "@/sordnerOverview/sordnerOverviewContextValue";

export function useSOrdnerOverview() {
  const ctx = useContext(SOrdnerOverviewContext);
  if (!ctx) {
    throw new Error("useSOrdnerOverview must be used within SOrdnerOverviewProvider");
  }
  return ctx;
}
